(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brellano-photo-strip"] && !Shopify.designMode) return;
  try {
    
(() => {
  const instances = new WeakMap();
  const initialize = root => {
    if (!root || instances.has(root)) return;
    const viewport = root.querySelector('.photo-strip__viewport');
    const track = root.querySelector('.photo-strip__track');
    const group = root.querySelector('.photo-strip__group');
    const toggle = root.querySelector('.photo-strip__toggle');
    const cards = [...group.children];
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const life = new AbortController();
    const listen = (target, type, callback, options = {}) => target.addEventListener(type, callback, {...options, signal:life.signal});
    let cycle = 0, position = 0, frame = 0, previous = 0, visible = false, hovered = false, focused = false, selected = false;
    let paused = root.dataset.autoplay !== 'true', ignoreInteraction = false;
    const speed = Math.max(10, Math.min(80, Number(root.dataset.speed) || 40));
    const canMove = () => !paused && !motion.matches && (ignoreInteraction || (!hovered && !focused)) && !selected && visible && !document.hidden && cycle > 0 && cards.length > 1;
    const stop = () => {cancelAnimationFrame(frame);frame=0;previous=0;};
    const tick = now => {
      frame=0;
      if (!canMove()) {previous=0;return;}
      if (previous) {
        position=(position + Math.min(now-previous,50)*speed/1000)%cycle;
        viewport.scrollLeft=position;
      }
      previous=now;
      frame=requestAnimationFrame(tick);
    };
    const update = () => {
      if(!hovered && !focused) ignoreInteraction=false;
      toggle.hidden=cards.length<2;
      toggle.disabled=motion.matches;
      const play=paused || motion.matches;
      toggle.setAttribute('aria-label',motion.matches ? 'Photo scrolling disabled by reduced motion preference' : play ? 'Play photo scrolling' : 'Pause photo scrolling');
      toggle.setAttribute('aria-pressed',String(!play));
      /* SVG parts have no .hidden property, so the attribute is set directly. */
      toggle.querySelector('[data-photo-pause]').toggleAttribute('hidden',play);
      toggle.querySelector('[data-photo-play]').toggleAttribute('hidden',!play);
      root.dataset.scrolling=canMove() ? 'playing' : 'paused';
      if (canMove() && !frame) frame=requestAnimationFrame(tick);
      else if (!canMove()) stop();
    };
    const measure = () => {
      cycle=group.getBoundingClientRect().width;
      track.querySelectorAll('[data-photo-clone]').forEach(copy=>copy.remove());
      if (cycle>0 && cards.length>1) {
        const copies=Math.ceil(viewport.clientWidth/cycle)+1;
        for(let i=0;i<copies;i++) {
          const copy=group.cloneNode(true);
          copy.dataset.photoClone='true';copy.setAttribute('aria-hidden','true');copy.setAttribute('inert','');copy.removeAttribute('role');
          copy.querySelectorAll('[data-shopify-editor-block],[data-photo-block],[id]').forEach(item=>{item.removeAttribute('data-shopify-editor-block');item.removeAttribute('data-photo-block');item.removeAttribute('id');});
          copy.querySelectorAll('img').forEach(image=>{image.alt='';});
          track.append(copy);
        }
        position=viewport.scrollLeft%cycle;
        viewport.scrollLeft=position;
      }
      update();
    };
    const pauseForInteraction = () => {paused=true;ignoreInteraction=false;update();};
    listen(toggle,'click',()=>{position=cycle ? viewport.scrollLeft%cycle : 0;paused=!paused;ignoreInteraction=!paused;update();});
    listen(viewport,'pointerdown',pauseForInteraction,{passive:true});
    listen(viewport,'wheel',event=>{if(event.shiftKey || Math.abs(event.deltaX)>Math.abs(event.deltaY))pauseForInteraction();},{passive:true});
    listen(viewport,'keydown',event=>{
      if(['ArrowLeft','ArrowRight','Home','End','PageUp','PageDown'].includes(event.key)) pauseForInteraction();
    });
    listen(root,'pointerenter',event=>{if(event.pointerType==='mouse'){hovered=true;update();}});
    listen(root,'pointerleave',()=>{hovered=false;update();});
    listen(root,'focusin',()=>{focused=true;update();});
    listen(root,'focusout',event=>{if(!root.contains(event.relatedTarget)){focused=false;update();}});
    listen(document,'visibilitychange',update);
    listen(motion,'change',update);
    const editorSection=root.closest('.shopify-section') || root;
    listen(editorSection,'shopify:section:select',()=>{selected=true;update();});
    listen(editorSection,'shopify:section:deselect',()=>{selected=false;update();});
    listen(root,'shopify:block:select',event=>{
      selected=true;update();
      const card=cards.find(item=>item.dataset.photoBlock===event.detail?.blockId);
      if(card) viewport.scrollLeft=card.offsetLeft-track.offsetLeft-20;
    });
    listen(root,'shopify:block:deselect',()=>{selected=false;update();});
    const resize=new ResizeObserver(measure);resize.observe(viewport);
    const intersection=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;update();},{threshold:.01});intersection.observe(root);
    const destroy=()=>{stop();life.abort();resize.disconnect();intersection.disconnect();instances.delete(root);};
    instances.set(root,{destroy});
    measure();
  };
  const findRoots=target=>target.querySelectorAll('[data-brellano-photo-strip]');
  findRoots(document).forEach(initialize);
  document.addEventListener('shopify:section:load',event=>findRoots(event.target).forEach(initialize));
  document.addEventListener('shopify:section:unload',event=>findRoots(event.target).forEach(root=>instances.get(root)?.destroy()));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brellano-reviews"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = root => {
    if (!root || root.dataset.bxtReady) return;
    root.dataset.bxtReady = 'true';
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    /* Thumbnails: the same product photos the buy box already loaded (catalog JSON in the shell). */
    try {
      const src = document.querySelector('[data-brellano-family-catalog]');
      const catalog = src ? JSON.parse(src.textContent) : null;
      root.querySelectorAll('[data-bxt-thumb]').forEach(el => {
        const [fam, col] = el.dataset.bxtThumb.split('/');
        const f = catalog?.families?.find(x => x.key === fam);
        const v = f?.variants?.find(x => x.key === col);
        const img = ((v && v.approved_gallery) || (f && f.approved_gallery) || [])[0];
        if (img && img.src) el.style.backgroundImage = 'url("' + String(img.src).replace(/([?&])width=\d+/, '$1width=120') + '")';
        else el.remove();
      });
    } catch (e) {}
    const rail = root.querySelector('[data-bxt-rail]');
    const dots = [...root.querySelectorAll('[data-bxt-dots] i')];
    if (rail && dots.length) {
      const cards = [...rail.querySelectorAll('.bxt-card:not(.bxt-card--empty)')];
      let raf = 0;
      const sync = () => {
        raf = 0;
        const mid = rail.getBoundingClientRect().left + rail.clientWidth / 2;
        let best = 0, dist = Infinity;
        cards.forEach((c, i) => { const r = c.getBoundingClientRect(); const d = Math.abs(r.left + r.width / 2 - mid); if (d < dist) { dist = d; best = i; } });
        dots.forEach((d, i) => d.classList.toggle('is-on', i === best));
      };
      rail.addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(sync); }, {passive: true});
    }
    root.querySelector('[data-bxt-cta]')?.addEventListener('click', () => {
      const shell = document.querySelector('[data-brellano-draft]') || document;
      shell.querySelector('[data-brellano-offer="trio"]')?.click();
      (shell.querySelector('.bx-deal') || document.getElementById('brellano-main') || shell).scrollIntoView({behavior: motion.matches ? 'auto' : 'smooth', block: 'start'});
    });
  };
  const all = () => document.querySelectorAll('[data-bxt]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all, {once: true}); else all();
  document.addEventListener('shopify:section:load', e => init(e.target.querySelector('[data-bxt]')));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brellano-video-reel"] && !Shopify.designMode) return;
  try {
    
(() => {
  const SEL = '.shopify-section.brellano-video-reel-section';
  const place = () => {
    if (window.Shopify?.designMode) return;
    const strip = document.querySelector('[data-brellano-draft] .mood-strip');
    document.querySelectorAll(SEL).forEach(sec => { if (strip && strip.previousElementSibling !== sec) strip.before(sec); });
  };
  document.addEventListener('shopify:section:unload', event => {
    const own = event.target.matches?.(SEL) ? null : event.target.querySelector(SEL);
    if (own) event.target.after(own);
  });
  document.addEventListener('shopify:section:load', () => requestAnimationFrame(place));

  const instances = new WeakMap();
  const init = root => {
    if (!root || instances.has(root)) return;
    const rail = root.querySelector('.bxv-rail');
    const orig = [...root.querySelectorAll('[data-bxv-card]')];
    const N = orig.length;
    if (!rail || !N) return;
    const desk = window.matchMedia('(min-width: 900px)');
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const life = new AbortController();
    const on = (t, e, f, o = {}) => t.addEventListener(e, f, {...o, signal: life.signal});
    orig.forEach((c, i) => { c.dataset.bxvI = i; });
    const loop = N > 1 && !window.Shopify?.designMode;
    if (loop) {
      const copy = () => orig.map(c => {
        const k = c.cloneNode(true);
        k.removeAttribute('data-shopify-editor-block');
        k.setAttribute('aria-hidden', 'true');
        k.querySelectorAll('button').forEach(b => { b.tabIndex = -1; });
        return k;
      });
      rail.prepend(...copy());
      rail.append(...copy());
      root.classList.add('bxv--loop');
    }
    const cards = [...rail.querySelectorAll('[data-bxv-card]')];
    const posters = () => cards.forEach(c => { const v = c.querySelector('video'); if (v && v.dataset.poster && !v.getAttribute('poster')) v.setAttribute('poster', v.dataset.poster); });
    if ('IntersectionObserver' in window) { const po = new IntersectionObserver(es => { if (es.some(e => e.isIntersecting)) { posters(); po.disconnect(); } }, {rootMargin: '800px 0px'}); po.observe(root); } else posters();
    const vid = c => c.querySelector('video');
    const ratios = new Map(), hasIO = 'IntersectionObserver' in window;
    let inView = !hasIO, active = loop ? N : 0, soundEl = null;
    const manual = new Set();
    const autoplay = () => root.dataset.autoplay === 'true' && !motion.matches;
    const visible = i => !hasIO || (ratios.get(i) || 0) >= .55;
    const mid = c => c.offsetLeft + c.offsetWidth / 2;
    const goTo = (c, smooth) => rail.scrollTo({left: mid(c) - rail.clientWidth / 2, behavior: smooth && !motion.matches ? 'smooth' : 'auto'});
    const nearest = () => {
      const rc = rail.scrollLeft + rail.clientWidth / 2;
      let best = active, d = Infinity;
      cards.forEach((c, i) => { const x = Math.abs(mid(c) - rc); if (x < d) { d = x; best = i; } });
      return best;
    };
    const setSound = el => {
      soundEl = el;
      cards.forEach(c => {
        const v = vid(c), b = c.querySelector('[data-bxv-mute]'), lit = c === el;
        if (v) v.muted = !lit;
        if (b) { b.setAttribute('aria-pressed', String(lit)); b.setAttribute('aria-label', lit ? 'Turn sound off' : 'Turn sound on'); b.querySelector('[data-bxv-off]').toggleAttribute('hidden', lit); b.querySelector('[data-bxv-on]').toggleAttribute('hidden', !lit); }
      });
    };
    const play = c => { const v = vid(c); if (!v) return; if (v.dataset.poster && !v.getAttribute('poster')) v.setAttribute('poster', v.dataset.poster); if (v.preload === 'none') v.preload = 'auto'; const p = v.play(); if (p && p.catch) p.catch(() => {}); };
    const pause = c => { const v = vid(c); if (v && !v.paused) v.pause(); };
    const dots = [...root.querySelectorAll('.bxv-dots i')];
    const sync = () => {
      cards.forEach((c, i) => {
        const center = i === active;
        c.classList.toggle('is-center', center);
        c.classList.toggle('is-idle', !center);
        const want = inView && (manual.has(c) || (autoplay() && (desk.matches ? visible(i) : center)));
        if (want) play(c); else pause(c);
      });
      if (soundEl) {
        const si = cards.indexOf(soundEl);
        if (!inView || (desk.matches ? !visible(si) : si !== active)) setSound(null);
      }
      dots.forEach((d, i) => d.classList.toggle('on', i === active % N));
    };
    const recenter = () => {
      if (!loop) return;
      const shift = active < N ? N : active >= 2 * N ? -N : 0;
      if (!shift) return;
      const from = cards[active], to = cards[active + shift];
      const fv = vid(from), tv = vid(to);
      if (fv && tv && !fv.paused) { try { tv.currentTime = fv.currentTime; } catch (e) {} }
      const hadSound = soundEl === from, wasManual = manual.has(from);
      rail.classList.add('bxv-jump');
      rail.scrollLeft += mid(to) - mid(from);
      active += shift;
      if (wasManual) { manual.delete(from); manual.add(to); }
      if (hadSound) setSound(to);
      sync();
      requestAnimationFrame(() => requestAnimationFrame(() => rail.classList.remove('bxv-jump')));
    };
    let ticking = false, idle = 0;
    on(rail, 'scroll', () => {
      if (!ticking) { ticking = true; requestAnimationFrame(() => { ticking = false; const n = nearest(); if (n !== active) { manual.forEach(c => { if (desk.matches ? false : c !== cards[n]) manual.delete(c); }); active = n; sync(); } }); }
      clearTimeout(idle); idle = setTimeout(recenter, 160);
    }, {passive: true});
    cards.forEach(c => {
      const v = vid(c), bar = c.querySelector('.bxv-bar i');
      if (!v) return;
      v.muted = true; v.setAttribute('playsinline', ''); v.removeAttribute('controls'); v.removeAttribute('autoplay');
      on(v, 'play', () => c.classList.add('is-playing'));
      on(v, 'pause', () => c.classList.remove('is-playing'));
      on(v, 'timeupdate', () => { if (bar && v.duration) bar.style.width = (v.currentTime / v.duration * 100).toFixed(1) + '%'; });
    });
    on(rail, 'click', event => {
      const c = event.target.closest('[data-bxv-card]');
      if (!c || !c.querySelector('video')) return;
      const shopBtn = event.target.closest('.bxv-shop');
      if (shopBtn) { shop(shopBtn); return; }
      const i = cards.indexOf(c), v = vid(c);
      if (i !== active) { goTo(c, true); manual.add(c); setSound(c); play(c); return; }
      if (v.paused) { manual.add(c); setSound(c); play(c); return; }
      setSound(soundEl === c ? null : c);
    });
    const shop = btn => {
      const shell = document.querySelector('[data-brellano-draft]') || document;
      const fam = btn.dataset.bxvShopFamily, color = btn.dataset.bxvShopColor;
      shell.dispatchEvent(new CustomEvent('brellano:select-product',{detail:{family:fam,color}}));
      requestAnimationFrame(() => {
        (document.getElementById('brellano-main') || shell).scrollIntoView({behavior: motion.matches ? 'auto' : 'smooth', block: 'start'});
      });
    };
    const cta = root.querySelector('[data-bxv-cta]');
    if (cta) on(cta, 'click', () => {
      const shell = document.querySelector('[data-brellano-draft]') || document;
      shell.querySelector('[data-brellano-offer="trio"]')?.click();
      (shell.querySelector('[data-brellano-color-picker]') || document.getElementById('brellano-main') || shell).scrollIntoView({behavior: motion.matches ? 'auto' : 'smooth', block: 'center'});
    });
    const nav = root.querySelector('[data-bxv-nav]');
    if (nav) {
      const arrows = [...nav.querySelectorAll('[data-bxv-dir]')];
      const navSync = () => {
        if (loop) { nav.hidden = false; arrows.forEach(a => { a.disabled = false; }); return; }
        nav.hidden = rail.scrollWidth <= rail.clientWidth + 4;
        arrows[0].disabled = active <= 0; arrows[1].disabled = active >= cards.length - 1;
      };
      arrows.forEach(btn => on(btn, 'click', () => {
        const next = cards[Math.max(0, Math.min(cards.length - 1, active + Number(btn.dataset.bxvDir)))];
        if (next) goTo(next, true);
      }));
      on(rail, 'scroll', navSync, {passive: true});
      on(window, 'resize', navSync);
      navSync();
    }
    let raf = 0;
    on(window, 'resize', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(() => { rail.classList.add('bxv-jump'); goTo(cards[active], false); requestAnimationFrame(() => rail.classList.remove('bxv-jump')); }); });
    let railObs = null, viewObs = null;
    if (hasIO) {
      railObs = new IntersectionObserver(entries => {
        entries.forEach(e => ratios.set(cards.indexOf(e.target), e.intersectionRatio));
        if (desk.matches) sync();
      }, {root: rail, threshold: [0, .25, .55, .75, 1]});
      cards.forEach(c => railObs.observe(c));
      viewObs = new IntersectionObserver(entries => { inView = entries[0].isIntersecting; if (!inView) manual.clear(); sync(); }, {threshold: .35});
      viewObs.observe(root);
    }
    instances.set(root, {destroy: () => { life.abort(); railObs?.disconnect(); viewObs?.disconnect(); cards.forEach(pause); instances.delete(root); }});
    on(desk, 'change', sync); on(motion, 'change', sync);
    on(document, 'visibilitychange', () => { if (document.hidden) cards.forEach(pause); else sync(); });
    rail.classList.add('bxv-jump');
    goTo(cards[active], false);
    requestAnimationFrame(() => { rail.classList.remove('bxv-jump'); sync(); });
  };
  const roots = t => t.querySelectorAll('[data-bxv]');
  const boot = () => { place(); roots(document).forEach(init); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once: true}); else boot();
  document.addEventListener('shopify:section:load', e => roots(e.target).forEach(init));
  document.addEventListener('shopify:section:unload', e => roots(e.target).forEach(r => instances.get(r)?.destroy()));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
